import { GoProComponent } from './go-pro/go-pro.component';
// import { MainCameraComponent } from './main-camera/main-camera.component';
import { RicohThetaZ1Component } from './ricoh-theta-z1/ricoh-theta-z1.component'
import { NctechIstarPulsarComponent } from './nctech-istar-pulsar/nctech-istar-pulsar.component'
import { RicohThetaVComponent } from './ricoh-theta-v/ricoh-theta-v.component'
import { Insta360OneXComponent } from './insta360-one-x/insta360-one-x.component';
import { Insta360Pro1Component } from './insta360-pro1/insta360-pro1.component';
import { Insta360Pro2Component } from './insta360-pro2/insta360-pro2.component'
import { GoproFusionComponent } from './gopro-fusion/gopro-fusion.component'
import { GoproFusionMaxComponent } from './gopro-fusion-max/gopro-fusion-max.component';
import { RicohThetaSComponent } from './ricoh-theta-s/ricoh-theta-s.component'
import { LabpanoPilotERAComponent } from './labpano-pilot-era/labpano-pilot-era.component'
import { LabpanoPilotOneComponent } from './labpano-pilot-one/labpano-pilot-one.component'
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: 'gopro', pathMatch: 'full' },
    { path: 'gopro', component: GoProComponent },
    { path: 'ricoh-theta-z1', component: RicohThetaZ1Component },
    { path: 'ricoh-theta-v', component: RicohThetaVComponent },
    { path: 'ricoh-theta-s', component: RicohThetaSComponent },
    { path: 'nctech-istar-pulsar', component: NctechIstarPulsarComponent },
    { path: 'insta360-one-x', component: Insta360OneXComponent },
    { path: 'insta360-pro1', component: Insta360Pro1Component },
    { path: 'insta360-pro2', component: Insta360Pro2Component },
    { path: 'gopro-fusion', component: GoproFusionComponent },
    { path: 'gopro-fusion-max', component: GoproFusionMaxComponent },
    { path: 'labpano-pilot-era', component: LabpanoPilotERAComponent },
    { path: 'labpano-pilot-one', component: LabpanoPilotOneComponent },
];

export const CamerasRoutes = RouterModule.forChild(routes);
